export function Logo({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="9" fill="var(--color-brand-600)" />
      <path
        d="M9.5 22V10.6c0-.33.27-.6.6-.6h5.3a4.3 4.3 0 0 1 0 8.6h-3.1"
        fill="none"
        stroke="white"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <circle cx="21.4" cy="21.6" r="1.9" fill="var(--color-brand-300)" />
    </svg>
  );
}
